import { LoggingService } from '@adaptiva/core/logging';
import { BaseActionOverlay, BeforeSubmitFn, OverlayService } from '@adaptiva/core/overlays';
import { SnackbarService } from '@adaptiva/core/snackbars';
import { TableSortService } from '@adaptiva/core/tables';
import { UiService } from '@adaptiva/core/ui';
import { BlacklistPayload, MetadataAuthoringManagerService } from '@adaptiva/metadata/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { take } from 'rxjs';
import { IBlacklistPropertiesOverlayContext } from './interfaces';

@Component({
	standalone: false,
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'ada-blacklist-properties-overlay',
	templateUrl: './blacklist-properties-overlay.component.html',
	providers: [TableSortService]
})
export class BlacklistPropertiesOverlayComponent extends BaseActionOverlay<IBlacklistPropertiesOverlayContext> implements OnInit {

	protected payload: BlacklistPayload;

	constructor(
		protected authoringManager: MetadataAuthoringManagerService,
		protected snackbars: SnackbarService,
		_logger: LoggingService,
		_overlayService: OverlayService,
		_uiService: UiService,
	) {
		super(_overlayService, _uiService, _logger);
	}

	public ngOnInit(): void {
		if (this.context)
			this.applyContext(this.context);
	}

	public override beforeSubmit: BeforeSubmitFn = (): boolean => {
		this._blacklist();
		return true;
	};

	protected override applyContext(_context: IBlacklistPropertiesOverlayContext): void {
		this.title = `${_context.payload.blacklistOrWhitelist ? 'Blacklist' : 'Whitelist'} ${_context.objectName}`;
		this.payload = _context.payload;
	}

	private _blacklist(): void {
		const _action: string = this.payload.blacklistOrWhitelist ? 'blacklist' : 'whitelist';

		this.authoringManager.blacklistMetadata(this.payload).pipe(
			take(1)
		).subscribe({
			next: () => {
				this.snackbars.display(`Successfully ${_action}ed ${this.context.objectName}`);
			},
			error: (e: Error) => {
				const _message: string = this.logger.extractErrorMessage(e);

				this.logger.error('BlacklistPropertiesOverlayComponent.blacklist', _message)();
				this.overlayService.error(`Failed to ${_action} ${this.context.objectName}`, _message);
			}
		});
	}

}
